/**
 * Razor Fintech Trading API
 *
 * Contact: api@razorsedge.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Product graduation state exposed to operators.
 */
export enum StrategyReadiness {

    Research = 'research',

    BacktestReady = 'backtest_ready',

    PaperReady = 'paper_ready',

    SandboxReady = 'sandbox_ready',

    LiveCanary = 'live_canary',

    LiveApproved = 'live_approved',

    Quarantined = 'quarantined'
}
